import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

// Renders a non-editable chip widget at the end of the last text block. The chip lives in a
// ProseMirror decoration (not the document), so it never reaches editor.getJSON() and the
// caller's plain-text output is unaffected. Cursor can't enter a widget — typing always
// inserts before it, matching the "[link] is appended after your message" UX.
export const LockedLinkChip = Extension.create({
    name: 'lockedLinkChip',
    addOptions() {
        return {
            label: 'Link',
            className: 'pl-locked-link-chip',
        };
    },
    addProseMirrorPlugins() {
        const { label, className } = this.options;
        const renderChip = () => {
            const dom = document.createElement('span');
            dom.className = className;
            dom.textContent = label;
            dom.contentEditable = 'false';
            return dom;
        };
        return [
            new Plugin({
                key: new PluginKey('lockedLinkChip'),
                props: {
                    decorations: state => {
                        let endPos = state.doc.content.size;
                        state.doc.descendants((node, pos) => {
                            if (node.isTextblock) {
                                endPos = pos + node.nodeSize - 1;
                            }
                            return true;
                        });
                        return DecorationSet.create(state.doc, [
                            Decoration.widget(endPos, renderChip, {
                                side: 1,
                                key: 'locked-link-chip',
                            }),
                        ]);
                    },
                },
            }),
        ];
    },
});
